import { LAYER_TYPES } from '../components/project-settings/types';

// The first type with a matching keyword wins, so Pedestrian goes before Road ("pedestrian_path").
export const LAYER_KEYWORDS: Record<keyof typeof LAYER_TYPES, string[]> = {
  Pedestrian: [
    'pedestrian',
    'plaza',
    'piazza',
    'square',
    'promenade',
    'footpath',
    'pjesa',
    'pješa',
    'fussgaenger',
    'fußgänger',
    'pedonal',
  ],
  Road: ['road', 'street', 'asphalt', 'driveway', 'lane', 'highway', 'path'],
  Sidewalk: ['sidewalk', 'walkway', 'pavement', 'curb'],
  Environment: ['environment', 'tree', 'grass', 'park', 'nature', 'landscape', 'vegetation', 'shrub', 'flower'],
  Building: ['building', 'house', 'structure', 'roof', 'wall', 'window', 'facade'],
  Unspecified: [],
};

/** Pedestrian crossings are part of the carriageway: "road_pedestrian_crossing" is a road, not a
 *  pedestrian zone, so these win over every keyword above. */
export const ROAD_CROSSING_KEYWORDS = [
  'crossing',
  'crosswalk',
  'zebra',
  'prijelaz',
  'prelaz',
  'zebrastreifen',
  'überweg',
  'uberweg',
  'attraversamento',
  'strisce',
];

/** Detection without the Pedestrian zone type (flag off): exactly the table before IDLC-1129. */
export const LEGACY_LAYER_KEYWORDS: Record<keyof typeof LAYER_TYPES, string[]> = {
  Road: ['road', 'street', 'asphalt', 'driveway', 'lane', 'highway', 'path'],
  Sidewalk: ['sidewalk', 'walkway', 'pedestrian', 'pavement', 'curb'],
  Environment: ['environment', 'tree', 'grass', 'park', 'nature', 'landscape', 'vegetation', 'shrub', 'flower'],
  Building: ['building', 'house', 'structure', 'roof', 'wall', 'window', 'facade'],
  Pedestrian: [],
  Unspecified: [],
};
